import * as yup from "yup";

const invoiceRowSchema = (isShiftJob, isDetails) =>
  yup.object().shape({
    ...(isDetails ? { applicantId: yup.string().required("Required") } : {}),
    ...(isShiftJob && isDetails ? { shiftSlug: yup.string().required("Required") } : {}),
    ...(!isDetails
      ? {
          totalEmployees: yup
            .string()
            .required("Required")
            .test((value, ctx) => {
              if (value) {
                const valueParsed = parseInt(value, 10);
                if (valueParsed < 1) return ctx.createError({ message: "Must be higher than 0" });
              }
              return true;
            }),
        }
      : {}),
  });

export default invoiceRowSchema;
